export default __webpack_public_path__ + "static/media/acess_request.96738410.svg";